
export default function VisionMission() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Vision &amp; Mission
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Driving the future of digital marketing with innovation, creativity, and results
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Vision */}
          <div className="bg-white rounded-lg p-8 shadow-lg">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-eye-line text-2xl text-blue-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Vision</h3>
            <p className="text-gray-600 text-lg">
              To become India's most result-oriented marketing partner for e-commerce brands.
            </p>
          </div>

          {/* Mission */}
          <div className="bg-white rounded-lg p-8 shadow-lg">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-6">
              <i className="ri-target-line text-2xl text-purple-600"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h3>
            <p className="text-gray-600 text-lg">
              Deliver measurable growth through creativity, analytics, and innovation.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
